/**
 * Created by Ning Jiang on 2/27/2018.
 */

import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {TimelineLite} from "gsap";
import {SymbolBurstAnimator} from "../../reelsymbol/SymbolBurstAnimator";
import {WildNudgeReelSymbol} from "../../reelsymbol/WildNudgeReelSymbol";
import {WildNudgeGameConfig} from "../../WildNudgeGameConfig";
import {WildNudgeSoundConfig} from "../../WildNudgeSoundConfig";

export class ScatterWinPresentationController extends WinPresentationController {

    private _scatterPositions:number[];
    private _timeline:TimelineLite;

    constructor(indexes:[number, number]) {
        super(indexes, {name : "ScatterWin", skippable : false});
    }

    protected parseFeatureGameData(data:ParsedGameData):void {
        this._scatterPositions = data.scatterPositions!;
    }

    protected hasWin():boolean {
        return this._gameData!.freespinTriggeredThisSpin!;
    }

    protected startWinPresentation():void {
        const timeline:TimelineLite = new TimelineLite({paused : true});
        timeline.add(() => SlotGame.sound.playEffect(WildNudgeSoundConfig.instance.FS_HEART_BEAT), 0);
        for(let reelId:number = 0; reelId < GameConfig.instance.REELS_NUM; reelId++) {
            for(let symbolId:number = 0; symbolId < GameConfig.instance.SYMBOLS_NUM_IN_REEL[2]; symbolId++) {
                const symbol:WildNudgeReelSymbol | null = <WildNudgeReelSymbol>Reels.getSymbol(reelId, symbolId);
                if(!symbol) {
                    debugger;
                    throw new Error(`ScatterWinPresentationController.startWinPresentation()Cannot find symbol at reel${reelId} symbol${symbolId}!`);
                }
                if(symbolId === this._scatterPositions[reelId]) {
                    const scatterTimeline:TimelineLite = new TimelineLite();
                    scatterTimeline.add(symbol.changeState({
                        state : WildNudgeGameConfig.instance.SYMBOL_STATES.win,
                        replay : true,
                        fadeInDuration : 0.1
                    }), 0);
                    scatterTimeline.add(SymbolBurstAnimator.playIdleFireWin(reelId, this._scatterPositions[reelId], [0, 7]), 0);
                    scatterTimeline.add(SymbolBurstAnimator.playIdleFireWin(reelId, this._scatterPositions[reelId]));
                    timeline.add(scatterTimeline, 0);
                } else {
                    // dim no scatter symbols.
                    timeline.add(() => symbol.dim(2, true), 0);
                }
            }
        }
        timeline.add(() => this.finish());
        this._timeline = timeline;
        this._timeline.play();
    }

    protected stopWinPresentation(isAborted:boolean):void {
        if(this._timeline && this._timeline.isActive()) {
            this._timeline.pause();
            this._timeline.kill();
        }

        SymbolBurstAnimator.abortWin();
    }
}